import { pgTable, text, boolean, timestamp, integer, index, foreignKey, numeric, jsonb } from 'drizzle-orm/pg-core';
import { sql } from 'drizzle-orm';
import { limitAction } from './enums';
import { telegramChannel } from './telegram';
import { trigger } from './trigger';
import { file } from './files';

/**
 * ChannelPass - Проходка в канал/чат
 * Отдельная сущность с собственной логикой для доступа к Telegram каналам
 */
export const channelPass = pgTable('ChannelPass', {
  id: integer().primaryKey().generatedAlwaysAsIdentity(),

  // Привязка к каналу
  channelId: integer().notNull(),

  // Обложка проходки для списка каналов (1:1)
  imageId: integer(),

  // Баннер для страницы детали канала (16:9)
  bannerImageId: integer(),

  // Ценообразование
  price: numeric({ precision: 12, scale: 2 }).notNull(),
  currency: text().default('UZS').notNull(),

  // Мультивалютное ценообразование
  prices: jsonb().$type<Record<string, number>>(), // { "USD": 99.99, "UZS": 1200000, "RUB": 9000 }
  baseCurrency: text().default('UZS'), // Основная валюта для расчётов

  // Длительность доступа
  durationDays: integer(), // null = бессрочный

  // Лимиты пользователей
  userLimit: integer(), // null = без лимита
  currentUserCount: integer().default(0).notNull(),

  // Ограничение по дате продаж
  saleEndDate: timestamp({ precision: 3, mode: 'date' }), // null = без ограничения по дате

  // Есть ли ограничения (для быстрой проверки)
  hasLimits: boolean().default(false).notNull(),

  // Действия при достижении лимита
  onLimitAction: limitAction().default('HIDE_FROM_STORE').notNull(),
  onLimitTriggerId: integer(), // FK → Trigger (если action = TRIGGER)
  onLimitDelayDays: integer().default(0).notNull(),

  // Статус
  isActive: boolean().default(true).notNull(),
  order: integer().default(0).notNull(),

  // Языковая аудитория проходки. [] = видна всем пользователям.
  targetLanguages: jsonb().$type<string[]>().notNull().default(sql`'[]'::jsonb`),

  // Timestamps
  deletedAt: timestamp({ precision: 3, mode: 'date' }),
  createdAt: timestamp({ precision: 3, mode: 'date' }).default(sql`CURRENT_TIMESTAMP`).notNull(),
  updatedAt: timestamp({ precision: 3, mode: 'date' }).$onUpdate(() => new Date()).notNull(),
}, (table) => [
  index('ChannelPass_channelId_idx').using('btree', table.channelId.asc().nullsLast()),
  index('ChannelPass_isActive_idx').using('btree', table.isActive.asc().nullsLast()),
  index('ChannelPass_order_idx').using('btree', table.order.asc().nullsLast()),
  index('ChannelPass_deletedAt_idx').using('btree', table.deletedAt.desc().nullsLast()),
  index('ChannelPass_targetLanguages_idx').using('gin', table.targetLanguages),
  foreignKey({
    columns: [table.channelId],
    foreignColumns: [telegramChannel.id],
    name: 'ChannelPass_channelId_fkey',
  }).onUpdate('cascade').onDelete('cascade'),
  foreignKey({
    columns: [table.onLimitTriggerId],
    foreignColumns: [trigger.id],
    name: 'ChannelPass_onLimitTriggerId_fkey',
  }).onUpdate('cascade').onDelete('set null'),
  foreignKey({
    columns: [table.imageId],
    foreignColumns: [file.id],
    name: 'ChannelPass_imageId_fkey',
  }).onUpdate('cascade').onDelete('set null'),
  foreignKey({
    columns: [table.bannerImageId],
    foreignColumns: [file.id],
    name: 'ChannelPass_bannerImageId_fkey',
  }).onUpdate('cascade').onDelete('set null'),
]);

// Note: ChannelPassProduct table has been removed.
// ChannelPass is now directly purchasable through OrderItem with targetType='CHANNEL_PASS'
